/**
 * Tracks real user interaction so API calls can slide the JWT idle window.
 * Presence heartbeats alone must not keep the session alive.
 */

let lastActivityAt = Date.now();

export function markSessionActivity() {
  lastActivityAt = Date.now();
}

export function getLastSessionActivityAt() {
  return lastActivityAt;
}

/** True when the user interacted recently enough that this request should extend the session. */
export function shouldSendSessionActivityHeader(withinMs = 2 * 60 * 1000) {
  return Date.now() - lastActivityAt < withinMs;
}
